export enum KYCQuestionType {
    Select,
    RadioButton,
    CheckBox,
    TextInput,
    NumberInput,
    SelectionList,
    Date,
    MultiPart,
    CountrySelect,
    CountrySelectionList,
}

export enum DynamicFormAPI {
    KYC,
    IP,
}

export enum FeedbackType {
    Nostopyynto = 1,
    Muutospyynto = 2,
}



// WEBPACK FOOTER //
// ./src/types/enums.ts